import script from "./AppSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSnackbar.vue?vue&type=script&setup=true&lang=ts"

import "./AppSnackbar.vue?vue&type=style&index=0&id=5c4606f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c4606f3"]])

export default __exports__